module.exports = __webpack_public_path__ + "img/ic-soybean-green.08d47323.svg";